import { TableDataShaping } from "./TableModels";
import { ApiResourceTableState } from "../../hooks/useApiResourceTable";

export const getShapingFromTable: <T extends Record<string, any>>(table: ApiResourceTableState<T>) => TableDataShaping =
  (table) => {
    const shaping: TableDataShaping = {
      globalFilter: table.globalFilter,
      columnFilters: table.columnFilters,
      sorting: table.sorting,
      ...table.pagination
    };

    return shaping;
  }